import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import "./Advertisement.css";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import IconButton from "@mui/material/IconButton";
import { useLocation } from "react-router-dom";

function AdvertisePayment() {
    let location = useLocation();
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card
          className="PaymentDetailsCard"
          sx={{ p: 3, textAlign: "center", width: "500px", height: "300px" }}
        >
          <Typography sx={{ fontWeight: "bold", fontSize: "24px"}}>
            Payment Details
          </Typography>
          <Typography sx={{ mt: 5 ,fontWeight: "bold", fontSize: "34px"}}>
            <IconButton sx={{ mr: -1 ,fontWeight: "bold"}}>
              <CurrencyRupeeIcon />
            </IconButton>
            <b>{location.state.pay_amount}</b>
          </Typography>
          <Typography  sx={{ mt: 5 }}>Please verify Details Before pay</Typography>
          <Button sx={{ mt: 5 }} variant="contained">
            Pay Now
          </Button>
        </Card>
      </Box>
    </>
  );
}

export default AdvertisePayment;
